import { configureStore } from "@reduxjs/toolkit"
import rootReducer from "./rootReducer"

const store = configureStore({
  reducer: rootReducer,
  middleware: (prev) => prev({ serializableCheck: false })
})

export default store